<div class="flex flex-col items-center p-8">
  <img width="46" height="46" src="/assets/images/warning.png" class="mb-4" />
  <span class="font-bold text-lg mb-4 text-gray-900 text-center">Verify your business to access this feature</span>
  <span class="text-base mb-6 text-gray-500 text-center"
    >Upload your business documents to verify your account. This helps us maintain a secure environment for all our
    users.</span
  >
  <div class="flex items-center justify-evenly w-full">
    <bey-button color="gray-outlined" placeholder="Cancel" (onClick)="onCancelClick()"></bey-button>
    <bey-button
      color="yellow"
      placeholder="Upload my documents"
      (onClick)="onUploadDocumentsCancelClick()"></bey-button>
  </div>
</div>
